import { Stack, Image, ImageFit, Label, PrimaryButton, DefaultButton, FontIcon, IStackTokens, Toggle, ComboBox, IComboBoxOption, IComboBox, TextField, IContextualMenuItem, DetailsList, SelectionMode, DetailsListLayoutMode, ISelection, MarqueeSelection, IconButton, initializeIcons, ConstrainMode } from '@fluentui/react';
import React, { FormEvent } from 'react';
import { TProduct, TSet } from '../constants/types';
import PokemonCards from './cardsComponent';
import Globals, { IsNull } from '../services/Globals';
import styles from '../styles/pokemon.module.scss';
import { NumberLiteralType } from 'typescript';
import ProductsComponent from './productsComponent';

export interface Iclientsv2Props {
    dev: boolean;
    site: string;
    apiUrl: string;
    token: string;
    username: string;
    commission: number;
}

export interface Iclientv2sState {
    clients: any[];
    doneclients: any[];
    allclients: any[];
    selection: ISelection;
    selectedClient: any;
    tt: string;
    products: any[];
    totalcost: number;
    eurprice: number;
    ammountofcardstotal: number;
};
  

export default class Clientsv2 extends React.Component<Iclientsv2Props, Iclientv2sState> {
    constructor(props: Iclientsv2Props) {
        super(props);
        this.GetClients = this.GetClients.bind(this);
        this.addTTandSendMail = this.addTTandSendMail.bind(this);
        this.GetEURPrice = this.GetEURPrice.bind(this);
        this.filterClients = this.filterClients.bind(this);

        this.state = {
            selection: null,
            clients: [],
            doneclients: [],
            allclients: [],
            selectedClient: null,
            tt: "",
            products: [],
            totalcost: 0,
            eurprice: 1,
            ammountofcardstotal: 0,
        }
        initializeIcons();
        this.GetEURPrice();
        this.GetClients();
    }

    GetEURPrice() {
        fetch(`https://${this.props.site}.nl/Backend?username=${this.props.username}&token=${this.props.token}&site={this.props.site}`, {
            method: 'GET',
            mode: 'cors',
        }).then((response) => response.json()).then((data) => {
            this.setState({eurprice: data as number});
        });
    }

    private async GetClients() {
        await fetch(`${this.props.apiUrl}/Clientsv2?sitename=${this.props.site}&username=${this.props.username}&token=${this.props.token}&site={this.props.site}`, {
            method: 'GET',
            mode: 'cors',
        }).then((response) => response.json()).then((data) => { 
            this.filterClients(data);
        }).catch( err => {
            console.log(err);
        });
    }

    private filterClients(data) {
        let clients = [];
        let doneclients = [];
        let allclients = data;
        data.forEach(d => {
            if (d.paid == true) {
                if (d.tt == null || d.tt == undefined || d.tt == "") {
                    clients.push(d);
                } else if (d.delivered == false) {
                    doneclients.push(d);
                }
            }
        });
        this.setState({clients: clients, doneclients: doneclients, allclients: allclients});
        setTimeout(() => {
            const elements = document.getElementsByClassName("ms-DetailsHeader-cellSizer");
            for (let i=0, l=elements.length; i<l; i++) {
                var event = new MouseEvent('dblclick', {
                    'view': window,
                    'bubbles': true,
                    'cancelable': true
                  });
                try {
                elements[i].dispatchEvent(event);
                } catch(err){

                }
            }
        }, 500);
    }

    private clientSelected(item?: any, index?: number, ev?: React.FocusEvent<HTMLElement, Element>) {
        this.setState({tt: item.tt, selectedClient: item, products: []} );

        let cardids= [];
        let products = [];
        let totalcost = 6.49;
        let ammountofcardstotal = 0;

        item.productids.split('|').forEach(productstr => {
            const productid = productstr.split(',')[3];
            const ammount = Number(productstr.split(',')[2]);
            ammountofcardstotal += ammount;
            
            fetch(`${this.props.apiUrl}/Productv2?productId=${productid}&username=${this.props.username}&token=${this.props.token}&site=${this.props.site}`, {
                method: 'GET',
            }).then((response) => response.json()).then((data) => {
                products.push({
                    id: data.id,
                    title: data.title,
                    setID: data.setID,
                    priceInEUR: data.priceInEUR,
                    version: "Product",
                    rarity: "Product",
                    available: productstr.split(',')[2],
                    imageNames: data.imageNames,
                    tags: data.tags,
                    imageUrls: [`https://${this.props.site}.nl/assets/products/${productid}/${data.imageNames?.split(',')[0]}`],
                });
                products.sort((a,b)=> a.number < b.number ? -1 : 1);
                products.sort((a,b) => a.name < b.name ? -1 : 1);
                totalcost += (Number(data.priceInEUR)) * ammount;
                this.setState({products:products, totalcost: totalcost});
            });
        });

        window.scrollTo(0, 0);
    }

    private async addTTandSendMail() {
        await fetch(`${this.props.apiUrl}/AddTTv2?sitename=${this.props.site}&clientid=${this.state.selectedClient.id}&TT=${this.state.tt}&username=${this.props.username}&token=${this.props.token}`, {
            method: 'GET',
        }).then((response) => response.json()).then((data) => { 
            this.GetEURPrice();
            this.GetClients();
            
            alert(data);

            this.setState({
                selection: null,
                clients: [],
                doneclients: [],
                allclients: [],
                selectedClient: null,
                tt: "",
                products: [],
                totalcost: 0,
                eurprice: 1,
                ammountofcardstotal: 0,
            });
    
            this.GetEURPrice();
            this.GetClients();
        });
    }

    private renderItemColumn = (item: any, index: any, column: any) => {
        let fieldContent = item[column.fieldName];
        switch (column.key) {
            default:
                return <span >{fieldContent}</span>;
        }
    };

    private copyToClipboard(text:string) {
        let clipBoardElem = document.createElement("textarea");
        document.body.appendChild(clipBoardElem);
        clipBoardElem.value = text;
        clipBoardElem.select();
        let successfulCopy = document.execCommand('copy');
        document.body.removeChild(clipBoardElem);
        if (successfulCopy) {
            
        } else {
            alert("Kopieren naar klembord mislukt");
        }
    }

    public render(): React.ReactElement<Iclientsv2Props> {
        console.log(this.state);
        return (   
            <Stack horizontal={false} tokens={{childrenGap:20}} className={styles.aPanel}>
                {this.state.selectedClient ?
                <Stack className={styles.aPanel}>
                    <Stack horizontal tokens={{childrenGap:20}}>

                        <Stack horizontal style={{width:"100%"}}>
                            <Stack>
                                <Stack className={styles.aPanel}>
                                    <Stack horizontal>
                                        {this.state.selectedClient.name.split(' ').map(p => {
                                            return  <div>
                                                        {p}<IconButton  iconProps={{iconName: 'Copy'}} onClick={()=>{this.copyToClipboard(p);}} />
                                                    </div>
                                        })}
                                    </Stack>
                                    <Stack>
                                        <Stack horizontal>
                                            {this.state.selectedClient.postalcode}<IconButton  iconProps={{iconName: 'Copy'}} onClick={()=>{this.copyToClipboard(this.state.selectedClient.postalcode);}} />&nbsp;{this.state.selectedClient.number}<IconButton  iconProps={{iconName: 'Copy'}} onClick={()=>{this.copyToClipboard(this.state.selectedClient.number);}} />
                                        </Stack>
                                        <Stack horizontal>
                                            {this.state.selectedClient.email}<IconButton  iconProps={{iconName: 'Copy'}} onClick={()=>{this.copyToClipboard(this.state.selectedClient.email);}} />
                                        </Stack>
                                    </Stack>
                                </Stack>
                                <Stack horizontal className={styles.aPanel}>
                                    <Label>Bedankt voor uw bestelling. Met vriendelijke groet van Team GamesCollectie.nl</Label><IconButton  iconProps={{iconName: 'Copy'}} onClick={()=>{this.copyToClipboard("Bedankt voor uw bestelling. Met vriendelijke groet van Team Pokemoncollectie.nl");}} />
                                </Stack>
                                <Stack horizontal className={styles.aPanel}>
                                    <Label>Aantal : {this.state.ammountofcardstotal}</Label>&nbsp; - &nbsp;
                                    <Label>Totaal : EUR: {this.state.totalcost.toFixed(2).toString()}</Label>&nbsp; - &nbsp;
                                    <Label>Betaald: EUR: {this.state.selectedClient.eur ? this.state.selectedClient.eur : "~ " + this.state.totalcost.toFixed(2).toString()}</Label>&nbsp; - &nbsp;
                                    {this.state.selectedClient.tt ? <a href={`https://jouw.postnl.nl/track-and-trace/${this.state.selectedClient.tt}-NL-${this.state.selectedClient.postalcode}?language=nl`} target='_blank'>TT: {this.state.selectedClient.tt}</a> : "Nog geen TT beschikbaar"}
                                </Stack>
                                <Stack horizontal className={styles.aPanel}>
                                    <TextField  disabled={this.state.selectedClient.tt ? true : false} value={this.state.tt} onChange={(e,v) => this.setState({tt: v})} />
                                    <PrimaryButton disabled={this.state.selectedClient.tt ? true : false} text="Voeg TT toe en stuur mail" onClick={this.addTTandSendMail} />
                                </Stack>
                            </Stack>
                        </Stack>

                    </Stack>
                    <h2>Ordered products</h2>
                    <Stack horizontal tokens={{childrenGap:20}} wrap>
                        {this.state.products.map(product => {
                            return <ProductsComponent apiUrl={this.props.apiUrl}
                                                      site={this.props.site}
                                                      username={this.props.username}
                                                      token={this.props.token}
                                                      viewer={true}
                                                      commission={this.props.commission}
                                                      product={product} 
                                                      onBuyClick={undefined} 
                                                      onImageClick={undefined} 
                                                      animationsEnabled={false} 
                                                      hideSwipe={false} 
                                                      saving={false}
                                                      selectedSite={this.props.site} 
                                                      dev={this.props.dev}
                                                      setMessage={()=>{}}
                                                      setError={()=>{}} />
                        })}
                    </Stack>
                </Stack>
                : <div></div>}
                <h1>Nieuwe bestellingen</h1>
                <Stack className={styles.aPanel}>
                    <div>
                        {this.state.clients.length < 1 ? <Label>Geen nieuwe bestellingen</Label> :
                        <DetailsList
                            onRenderRow={ (props, defaultRender) => (
                                props.item["paid"] == true ? 
                                <div>
                                    {defaultRender({...props, className: styles.paid})}            
                                </div> :
                                <div>
                                    {defaultRender({...props, className: styles.notpaid})}            
                                </div>
                                ) }
                            items={this.state.clients}
                            selectionMode={SelectionMode.single}
                            isHeaderVisible={true}
                            selection={this.state.selection}
                            selectionPreservedOnEmptyClick={true}
                            onActiveItemChanged={this.clientSelected.bind(this)}
                        />}
                    </div>
                </Stack>
                <Stack className={styles.aPanel}>
                    <h1>Bestellingen onderweg</h1>
                    
                    <DetailsList
                        compact
                        layoutMode={DetailsListLayoutMode.fixedColumns}
                        onRenderItemColumn={this.renderItemColumn}
                        onRenderRow={ (props, defaultRender) => (
                            props.item["paid"] == true ? 
                            <div>
                                {defaultRender({...props, className: styles.paid})}            
                            </div> :
                            <div>
                                {defaultRender({...props, className: styles.notpaid})}            
                            </div>
                            ) }
                        items={this.state.doneclients}
                        selectionMode={SelectionMode.single}
                        isHeaderVisible={true}
                        selection={this.state.selection}
                        selectionPreservedOnEmptyClick={true}
                        onActiveItemChanged={this.clientSelected.bind(this)}
                    />
                    
                </Stack>
                <Stack className={styles.aPanel}>
                    <h1>Bestelgeschiedenis</h1>
                    
                    <DetailsList
                        compact
                        layoutMode={DetailsListLayoutMode.fixedColumns}
                        onRenderItemColumn={this.renderItemColumn}
                        onRenderRow={ (props, defaultRender) => (
                            props.item["paid"] == true ? 
                            <div>
                                {defaultRender({...props, className: styles.paid})}            
                            </div> :
                            <div>
                                {defaultRender({...props, className: styles.notpaid})}            
                            </div>
                            ) }
                        items={this.state.allclients}
                        selectionMode={SelectionMode.single}
                        isHeaderVisible={true}
                        selection={this.state.selection}
                        selectionPreservedOnEmptyClick={true}
                        onActiveItemChanged={this.clientSelected.bind(this)}
                    />
                    
                </Stack>
            </Stack>
        );
    }
}